/**
 * P&L Overview tab (A7Y-2054): headline cards + the three finance charts,
 * laid out in a clean responsive grid. Presentational — takes a `PnlSummary`.
 */
import type { PnlSummary } from "@a7y/types";
import { SummaryCards } from "./SummaryCards";
import { RevenueByTierChart } from "./charts/RevenueByTierChart";
import { SpendByCategoryPie } from "./charts/SpendByCategoryPie";
import { SpendVsRevenueChart } from "./charts/SpendVsRevenueChart";

export function OverviewTab({ summary }: { summary: PnlSummary }) {
  return (
    <div className="space-y-6">
      <SummaryCards totals={summary.totals} />

      <SpendVsRevenueChart monthly={summary.monthly} />

      <div className="grid gap-6 lg:grid-cols-2">
        <SpendByCategoryPie data={summary.spendByCategory} />
        <RevenueByTierChart data={summary.revenueByTier} />
      </div>
    </div>
  );
}
